<template>
  <div>
    <Banner/>
    <Introduction />
    <About />
    <Services />
    <Skill />
    <!-- <Project /> -->
    <Counter />
    <br/>
    <!-- <Pricing /> -->
    <!-- <Video /> -->
    <Testimonial />
    <Work />
    <!-- <Team /> -->
    <Blog />
    <Faq />
    <Customer />
  </div>
</template>

<script>
  import Banner from '@/components/Home/Banner';
  import Introduction from '@/components/Home/Introduction';
  import About from '@/components/Home/About';
  import Services from '@/components/Home/Services';
  import Skill from '@/components/Home/Skill'
  import Project from '@/components/Home/Project'
  import Faq from '@/components/Home/Faq'
  import Counter from '@/components/Home/Counter'
  // import Pricing from '@/components/Home/Pricing'
  import Video from '@/components/Home/Video';
  import Testimonial from '@/components/Home/Testimonial';

  import Work from '@/components/Home/Work';
  import Team from '@/components/Home/Team';
  import Blog from '@/components/Home/Blog';
  import Customer from '@/components/Home/Customer';

  export default {
      name: "HomeView",
      data() {
          return {};
      },
      components: {
        Banner,
        Introduction,
        About,
        Services,
        Skill,
        Project,
        Faq,
        Counter,
        // Pricing,
        Video,
        Testimonial,
        Work,
        Team,
        Blog,
        Customer
    }
  }
</script>
